module.exports = __webpack_public_path__ + "assets/media/3.f21f606c.wav";